module.exports = __webpack_public_path__ + "img/parliament-3.5a7f7917.jpg";